angular.module('gym.invoices').controller('AddAdjustmentCtrl', ["$scope", "$rootScope", "$modalInstance", "$filter", "$http", "flash", "contact", function($scope, $rootScope, $modalInstance, $filter, $http, flash, contact) {
  var gym;
  gym = $rootScope.gym;
  $scope.currency = gym.currency_symbol;
  $scope.adjustment = {
    due_date: gym.today
  };
  $scope.memberships = contact.memberships;
  $scope.paymentCategories = [['non_debit_cash', 'Cash adjustment'], ['non_debit_pos', 'POS Sale adjustment'], ['non_debit_other', 'Other adjustment']];
  if (gym.has_payment_provider) {
    $scope.paymentCategories.unshift(['non_debit_autopayments', 'Adjustment for an Autopayment']);
  }
  $scope.membershipWithDate = function(membership) {
    var date;
    date = $filter('date')(membership.start_date);
    return `${membership.label} (starts: ${date})`;
  };
  $scope.submit = function() {
    var params, path;
    $scope.isLoading = true;
    $scope.error = '';
    path = `gyms/${gym.id}/non_debit_payments`;
    params = {
      contact_id: contact.id,
      non_debit_payment: $scope.adjustment
    };
    return $http.post(path, params).then(function(data) {
      return $modalInstance.close();
    }, function(response) {
      $scope.error = response.data.error;
      return $scope.isLoading = false;
    });
  };
  $scope.isFormValid = function() {
    return $scope.adjustment.amount && $scope.adjustment.membership_id;
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
